import { ProductCardTemplate } from 'components/UI/ProductCard';
import { memo } from 'react';
import { ModesProps } from '../props';

function GridAtomic(props: ModesProps) {
  return (
    <ProductCardTemplate
      variant="grid"
      product={props.product}
      packingSelected={props.packingSelected}
      getLowPrice={props.getLowPrice}
      addInCart={props.addInCart}
      selectedTypeSale={props.selectedTypeSale}
      buy={props.buy}
      showModalComposition={props.showModalComposition}
      onSelectPacking={props.handleOnSelectPacking}
      isExclusiveOffer={props.isExclusiveOffer}
    />
  );
}

export default memo(GridAtomic);
